import React, { ReactElement, ReactNode, useContext } from 'react';
import styled from 'styled-components/native';

import { Footer } from 'components/Footer';
import {
  ScreenResponsiveLayoutContext,
  useGetDynamicContentStyles,
} from 'components/ResponsiveLayout';
import {
  getIsMediumOrNative,
  getIsSmall,
} from 'components/Screens/ContentScreens/Resources/util';
import { Text } from 'components/Text';

//
// Generic Containers
//
const ColumnContainerStatic = styled.View`
  flex: 1;
  min-height: auto;
  flex-basis: auto;
  background-color: white;
  flex-direction: row;
  justify-content: space-between;
`;

const Wrapper = styled.View``;

export const ColumnContainer = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const styles = useGetDynamicContentStyles();
  const { screenWidth } = useContext(ScreenResponsiveLayoutContext);
  const isSmall = getIsSmall(screenWidth);
  const isMedium = getIsMediumOrNative(screenWidth, isSmall);

  const horizontalPadding =
    isMedium || isSmall
      ? styles.resourcesHorizontalPaddingNarrow
      : styles.resourcesHorizontalPadding;
  const verticalPadding =
    isMedium || isSmall
      ? styles.resourcesVerticalPaddingNarrow
      : styles.resourcesVerticalPadding;

  return (
    <Wrapper>
      <ColumnContainerStatic
        style={{
          paddingLeft: horizontalPadding,
          paddingRight: horizontalPadding,
          paddingTop: verticalPadding,
          paddingBottom: verticalPadding,
          flexWrap: isSmall ? 'wrap' : 'nowrap',
        }}
      >
        {children}
      </ColumnContainerStatic>
      <Footer />
    </Wrapper>
  );
};

export const View = styled.View``;

//
// Left Column
//

export const LeftColumn = styled.View`
  width: 30%;
  min-width: 185px;
  max-width: 267px;
`;

export const LeftColumnTitle = styled(Text)`
  font-size: 40px;
  color: ${props => props.theme.color.overlay.primary};
  margin-bottom: 35px;
  text-align: left;
`;

export const LeftColumnTextLink = styled(Text)`
  color: #1a80a2;
  font-size: 20px;
  line-height: 50px;
`;

//
// Right Column
//

export const RightColumn = styled.View`
  min-height: auto;
  max-width: 725px;
  align-items: flex-start;
`;

export const RightColumnTitleContainer = styled.View`
  margin-bottom: 40px;
`;

export const RightColumnBodyContainer = styled.View`
  width: 100%;
`;

export const AboutUsTitle = styled(Text)`
  font-weight: bold;
  color: ${props => props.theme.color.overlay.primary};
`;

export const AboutUsSubtitle = styled(Text)`
  color: ${props => props.theme.color.overlay.primary};
`;

export const AddressContainer = styled.View``;

export const BodyText = styled(Text)`
  font-size: 18px;
  line-height: 24px;
  color: ${props => props.theme.color.overlay.primary};
`;
